<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="docCatText"
    item-value="docCatCd"
    :label="label"
    :exceptCdList="exceptCdList"
    :exceptComparator="exceptComparator"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'SaRequiredDocInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0241')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    exceptCdList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  methods: {
    exceptComparator(item, except) {
      return item.docCatCd == except.docCatCd && item.docCatCd != this.model
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {
        validOnly: this.validOnly,
      }

      const elements = await API.get('/master/sa/requiredDoc', params)
      elements.forEach((element) => {
        element['docCatText'] = element['docCatCd'] + ' : ' + element['docCatName']
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0241') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
